import INTRO_IMG1 from "../../pre-order/image/1.png";
import INTRO_IMG2 from "../../pre-order/image/2.png";
import INTRO_IMG3 from "../../pre-order/image/3.png";
import { useNavigate } from "react-router-dom";

const OnboardingPreorderShortcut = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/boss/onboarding/preorder-sales");
  };

  return (
    <div className="w-full h-[100dvh] overflow-y-auto max-w-[480px] mx-auto bg-white">
      <div className="flex flex-col p-4 w-full space-y-6">
        <div className="space-y-2">
          <h1 className="text-4xl font-bold bg-green-500 text-white inline px-4">
            예약 판매
          </h1>
        </div>

        <div className="space-y-36">
          <div>
            <div className="flex items-start ">
              <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
                1
              </div>
              <h1 className="text-3xl font-bold">사장님의 랜덤 마감팩 결제</h1>
            </div>
            <div className="flex justify-center items-center h-48 mt-8 ">
              <img
                src={INTRO_IMG1}
                alt="예약 판매 안내"
                className="max-h-56 bg-gray-200 rounded-2xl"
              />
            </div>
          </div>
          <div>
            <div className="flex items-start">
              <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
                2
              </div>
              <h1 className="text-3xl font-bold">
                남았으면 팔고, <br /> 안남았으면 취소!
              </h1>
            </div>
            <div className="flex items-start">
              <p className="text-lg text-red-500 ml-10">
                취소하지 않으면 자동 확정됩니다!
              </p>
            </div>
            <div className="flex justify-center items-center h-48 mt-8">
              <img
                src={INTRO_IMG2}
                alt="슬라이드 2 이미지"
                className="max-h-56 mt-16 bg-gray-200 rounded-2xl"
              />
            </div>
          </div>
          <div>
            <div className="flex items-start">
              <div className="text-2xl font-bold bg-blue-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-2">
                3
              </div>
              <h1 className="text-3xl font-bold">
                손님 도착시 <br /> 랜덤팩을 전달!
              </h1>
            </div>
            <div className="flex items-start">
              <p className="text-lg text-gray-500 ml-10">
                가격에 맞게 소분만 해서 전달하면 돼요!
              </p>
            </div>
            <div className="flex justify-center items-center h-48">
              <img
                src={INTRO_IMG3}
                alt="슬라이드 3 이미지"
                className="max-h-56 bg-gray-200 rounded-2xl mt-16"
              />
            </div>
          </div>
        </div>
        <button
          onClick={handleClick}
          className="max-w-[480px] mx-auto w-full py-3.5 bg-primary text-white font-semibold rounded-2xl transition duration-150 active:brightness-90 pointer-events-auto"
        >
          다음
        </button>
      </div>
    </div>
  );
};

export default OnboardingPreorderShortcut;
